import {
  OrderBulkDto,
  OrderShippingMethod,
} from '@tiendanube/common/src/domains/orders/orders/OrderBulkResponseDto';
import Status from '@tiendanube/common/src/enums/Status';
import { SHIPPING_METHOD_CODE_OCA } from 'domains/Shipping/ShippingMethods/constants';
import {
  fulfillmentStatusFilter,
  paymentStatusFilter,
} from '../../ordersService';

export const fulfillmentOrdersFromSelectedOrderIds = (
  selectedOrderIds: string[],
  fulfillmentOrders: OrderBulkDto[],
) =>
  fulfillmentOrders.filter(({ orderId }) => selectedOrderIds.includes(orderId));

export const shippingMethodFromOrdersBySelectedOrderIds = (
  selectedOrdersIds: string[],
  ordersShippingMethods: OrderShippingMethod[],
) =>
  ordersShippingMethods.filter(({ orderId }) =>
    selectedOrdersIds.includes(orderId),
  );

export const checkCustomPaymentProvider = (key, value) =>
  key === 'paymentProvider' && value === 'custom';

export const hasOca = (orderShippingMethod: OrderShippingMethod) =>
  orderShippingMethod.shipping === SHIPPING_METHOD_CODE_OCA;

export const areFiltersEquals = (
  filters1,
  filters2,
  ignorePagination = true,
) => {
  if (ignorePagination) {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    filters1 = (({ perPage, page, ...newFilters }) => newFilters)(filters1);
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    filters2 = (({ perPage, page, ...newFilters }) => newFilters)(filters2);
  }

  const keys = Object.keys(filters1);

  const filtersWithMultipleValues = [
    paymentStatusFilter,
    fulfillmentStatusFilter,
  ];

  for (const key of keys) {
    const val1 = filters1[key];
    const val2 = filters2[key];

    if (val1 === val2) {
      continue;
    }

    if (val1 === undefined || val2 === undefined) {
      return false;
    }

    if (key === 'status') {
      if (
        (val1 === '' && val2 === Status.OPEN) ||
        (val1 === Status.OPEN && val2 === '')
      ) {
        continue;
      }
      return false;
    }

    // Split comma-separated strings, trim whitespace, and sort them for comparison
    if (filtersWithMultipleValues.includes(key)) {
      const val1Set = val1
        .split(',')
        .map((v) => v.trim())
        .sort();
      const val2Set = val2
        .split(',')
        .map((v) => v.trim())
        .sort();

      if (
        val1Set.length !== val2Set.length ||
        !val1Set.every((value, index) => value === val2Set[index])
      ) {
        return false;
      }
    }
    return false;
  }

  return true;
};
